import {
	AnalyticsStep,
	InsertTypeAheadStep,
	LinkMetaStep,
	SetAttrsStep,
} from '@atlaskit/adf-schema/steps';
import {
	AddMarkStep,
	AddNodeMarkStep,
	AttrStep,
	DocAttrStep,
	RemoveMarkStep,
	RemoveNodeMarkStep,
	type Step,
} from '@atlaskit/editor-prosemirror/transform';

function stepHasMarkConsideredAsContentChange(
	step: AddMarkStep | RemoveMarkStep | AddNodeMarkStep | RemoveNodeMarkStep,
): boolean {
	const { name } = step.mark.type;
	return name === 'annotation';
}

/**
 * This function is used to determine if the doc content changed by a step.
 * - Changes like bold or text color are not considered as doc content change.
 * - Changes like comment are considered as doc content change, will will trigger keyword decorations update.
 *   - This will cost a network request to fetch the keyword regex.
 *   - This can be optimized to skip the network request but I think it's not necessary for now.
 * steps from sanitizeFilteredStep in platform/packages/editor/editor-plugin-collab-edit/src/pm-plugins/track-and-filter-spamming-steps.ts
 */
export function noContentChangedInStep(step: Step): boolean {
	return (
		// bold will trigger AddMarkStep and RemoveMarkStep
		(step instanceof AddMarkStep && !stepHasMarkConsideredAsContentChange(step)) ||
		(step instanceof RemoveMarkStep && !stepHasMarkConsideredAsContentChange(step)) ||
		// add mark to node
		(step instanceof AddNodeMarkStep && !stepHasMarkConsideredAsContentChange(step)) ||
		(step instanceof RemoveNodeMarkStep && !stepHasMarkConsideredAsContentChange(step)) ||
		// update node attribute
		step instanceof AttrStep ||
		// update doc attribute
		step instanceof DocAttrStep ||
		// tick action item will trigger SetAttrsStep
		step instanceof SetAttrsStep ||
		// change link text will trigger LinkMetaStep
		step instanceof LinkMetaStep ||
		// type / typeahead will trigger InsertTypeAheadStep
		step instanceof InsertTypeAheadStep ||
		step instanceof AnalyticsStep
	);
}
